import * as QueueActionTypes from '../../actions/queue/types';

export function queueReducer(state = [], action) {
    switch (action.type) {
        case QueueActionTypes.ENQUEUE:
            return [...state, action.payload];

        case QueueActionTypes.DEQUEUE:
            const [, ...nextState] = state;
            return nextState;

        case QueueActionTypes.REMOVE:
            const notificationId = action.payload;
            return state.filter((id) => id !== notificationId);

        default:
            return state;
    }
}
